import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Link to="/" className="text-sm font-semibold text-accent hover:opacity-80 transition-opacity">
            {import.meta.env.VITE_SITE_NAME}
          </Link>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <FooterLink to="/privacy">Конфиденциальность</FooterLink>
            <FooterLink to="/terms">Соглашение</FooterLink>
            <FooterLink to="/dmca">DMCA</FooterLink>
            <FooterLink to="/contact">Контакты</FooterLink>
          </nav>

          <p className="text-sm text-muted/75">
            © {new Date().getFullYear()} {import.meta.env.VITE_SITE_NAME}
          </p>
        </div>
      </div>
    </footer>
  )
}

function FooterLink({ to, children }) {
  return (
    <Link to={to} className="text-sm text-muted hover:text-fg hover:underline underline-offset-4 transition-colors">
      {children}
    </Link>
  )
}
